import React, { FC, useEffect, useState } from 'react';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { Grid, Tooltip, Switch, IconButton, Menu, MenuItem, Box } from '@mui/material';
import { SCUIContent } from '../../atomic/organisms';
import { SCUICustomDataGrid, SCUIGeneralDrawer } from '../../atomic/molecules';
import { CookieManagementQuery } from '../../services/query';
import { useTranslation } from 'react-i18next';
import { SCUICookieTypeDrawerContent } from './components/SCUICookieTypeDrawerContent';
import { SCUIButton } from '../../atomic/atoms';
import TimeHelper from '../../utils/time';
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { CKT, cktCls } from './cookieType.classes';

export const CookieType: FC<any> = () => {
    const { t } = useTranslation();
    const [state, setState] = React.useState({
        right: false,
    });
    const [cookieType, setCookieType] = React.useState([]);
    const [selectedCookietype, setSelectedCookieType] = React.useState<any>();
    const onDrawerOpen = () => setState({ ...state, right: true });
    const onDrawerClose = () => setState({ ...state, right: false });
    const [refresh, setRefresh] = useState(false);

    const refreshSmsTemplate = () => {
        setRefresh((prevLoading) => !prevLoading);
    };

    useEffect(() => {
        GetCookieType();
    }, [refresh]);

    const columns: ExtendedGridColDef[] = [
        {
            field: 'id',
            headerName: 'Çerez ID',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            maxWidth: 120,
        },
        {
            field: 'cookieTypeName',
            headerName: 'Çerez Tipi',
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params: any) => {
                return (
                    <div>
                        <Tooltip title={params.row.cookieTypeName}>
                            <p>{params.row.cookieTypeName}</p>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            field: 'cookieTypeDescripton',
            headerName: 'Çerez Tipi Açıklaması',
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params: any) => {
                return (
                    <div>
                        <Tooltip title={params.row.cookieTypeDescripton}>
                            <p>{params.row.cookieTypeDescripton}</p>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            field: 'updateBy',
            headerName: 'Güncelleyen Kişi',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'updateDate',
            headerName: 'Güncellenme Tarihi',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'priority',
            headerName: 'Öncelik Sırası',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            maxWidth: 120,
        },
        {
            field: 'status',
            headerName: t('customerInformation.isActive'),
            width: 130,
            renderCell: (params: any) => (
                <Switch
                    checked={params.value}
                    color="primary"
                    readOnly
                    className={cktCls(CKT.input, CKT.inputSwitch, CKT.gridSwitchStatus)}
                />
            ),
        },
        {
            field: 'deneme ',
            headerName: ' ',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            maxWidth: 120,
            renderCell: (params: any) => {
                const handleClick = (popupState: any, tur: string) => {
                    popupState.close();
                    switch (tur) {
                        case 'gotoDetail': {
                            setSelectedCookieType(params.row);
                            onDrawerOpen();
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                };
                return (
                    <PopupState variant="popover" popupId="demo-popup-menu">
                        {(popupState: any) => (
                            <React.Fragment>
                                <IconButton
                                    {...bindTrigger(popupState)}
                                    className={cktCls(CKT.input, CKT.inputIconButton, CKT.rowActionsTrigger)}
                                >
                                    {' '}
                                    <MoreVertIcon className="svg_icons" />{' '}
                                </IconButton>
                                <Menu {...bindMenu(popupState)}>
                                    <MenuItem
                                        className={cktCls(CKT.input, CKT.inputMenuItem, CKT.rowActionEdit)}
                                        onClick={() => handleClick(popupState, 'gotoDetail')}
                                    >
                                        {t('general.edit')}{' '}
                                    </MenuItem>
                                    {/* <MenuItem onClick={() => handleClick(popupState, "delete")}>{t("general.delete")} </MenuItem> */}
                                </Menu>
                            </React.Fragment>
                        )}
                    </PopupState>
                );
            },
        },
    ];
    const GetCookieType = () => {
        CookieManagementQuery.ListOfCookieType()
            .then((res: any) => {
                if (res) {
                    console.info(res);
                    let parseData = res.data.map((item: any) => {
                        return {
                            id: item.cookieTypeId,
                            cookieTypeName: item.cookieTypeName || '-',
                            cookieTypeDescripton: item.cookieTypeDescripton || '-',
                            priority: item.priority || 99,
                            updateDate: (item.updateDate && TimeHelper.formatDate(item.updateDate)) || '-',
                            updateBy: item.updateBy || '-',
                            status: item.status || false,
                        };
                    });
                    setCookieType(parseData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };
    return (
        <SCUIContent className={`${CKT.page} `}>
            <Grid
                className={CKT.titleArea}
                size={{
                    lg: 10,
                    md: 12,
                    xs: 12,
                }}
            >
                <h1 className="headtxt">{'Çerez Tipi Yönetimi Sayfası'}</h1>
            </Grid>
            <Grid
                className={CKT.toolbar}
                container
                justifyContent="flex-end"
                size={{
                    xs: 12,
                    sm: 12,
                }}
            >
                <SCUIButton
                    text={'Çerez Tipi Ekle'}
                    sizeType="fixed"
                    type="primary"
                    size={'l'}
                    className={cktCls(CKT.input, CKT.inputButton, CKT.btnAddCookieType)}
                    onClick={() => {
                        setSelectedCookieType([]);
                        onDrawerOpen();
                    }}
                ></SCUIButton>
            </Grid>
            <SCUIGeneralDrawer
                open={state['right']}
                anchor="right"
                width={'80rem'}
                onClose={(event: any, reason: any) => {
                    if (reason === 'backdropClick') {
                        setState({ ...state, right: false });
                        //  setStateTrigger({ ...stateTrigger, right: false });
                    }
                }}
            >
                <SCUICookieTypeDrawerContent
                    selectedRow={selectedCookietype}
                    onCloseMenu={onDrawerClose}
                    onUpdate={refreshSmsTemplate}
                    cookieType={cookieType}
                />
            </SCUIGeneralDrawer>
            <Box className={CKT.datagrid}>
                <SCUICustomDataGrid randomId rows={cookieType} columns={columns} />
            </Box>
        </SCUIContent>
    );
};
